import {
  TICKET_STATUS, STATUS_COLORS, PRIORITY, PRIORITY_COLORS, CENTER_STATUS, CENTER_STATUS_COLORS,
  SLA_COLORS, slaTone, fmtElapsed, hoursSince,
} from "@/lib/format";

const Dot = ({ label, color, testid }) => (
  <span data-testid={testid} className="inline-flex items-center gap-1.5 text-[11px] uppercase tracking-[0.14em] font-medium whitespace-nowrap" style={{ color }}>
    <span className="w-1.5 h-1.5 rounded-full shrink-0" style={{ background: color }} />
    {label}
  </span>
);

export const TicketStatusBadge = ({ status }) => (
  <Dot testid="ticket-status-badge" label={TICKET_STATUS[status]} color={STATUS_COLORS[status]} />
);
export const CenterStatusBadge = ({ status }) => (
  <Dot testid="center-status-badge" label={CENTER_STATUS[status]} color={CENTER_STATUS_COLORS[status]} />
);
export const PriorityBadge = ({ priority }) => (
  <span data-testid="ticket-priority-badge" className="text-[11px] uppercase tracking-[0.14em]" style={{ color: PRIORITY_COLORS[priority] }}>
    {PRIORITY[priority]}
  </span>
);

export const SlaBadge = ({ label, since, testid = "sla-indicator" }) => {
  if (!since) return null;
  const h = hoursSince(since);
  const color = SLA_COLORS[slaTone(h)];
  return (
    <span data-testid={testid} data-tone={slaTone(h)} className="inline-flex items-center gap-1.5 text-[11px] text-warm-text whitespace-nowrap">
      <span className="w-2 h-2 rounded-full" style={{ background: color }} />
      {label} <strong className="font-semibold" style={{ color }}>{fmtElapsed(h)}</strong>
    </span>
  );
};

export const NewBadge = () => (
  <span data-testid="new-badge" className="inline-block rounded-full bg-gold text-noir text-[10px] font-bold uppercase tracking-[0.18em] px-2.5 py-0.5 shadow-[0_0_14px_-2px_rgba(212,175,55,0.7)]">
    Nuovo
  </span>
);
